import PropTypes from 'prop-types';
import React from 'react';

import { resetPasswordLock } from '../../config/auth0-config';
import LoginStylingStore from '../../stores/LoginStylingStore';

const getState = () => (
  {
    styling: LoginStylingStore.getState(),
  }
);

export default class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = getState();
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    this.stylingSubscription = LoginStylingStore.addListener(this._onChange);

    resetPasswordLock.hide();
    if (this.state.styling.theme) {
      const theme = {
        logo: `/assets/logo/${this.state.styling.logo}`,
        primaryColor: '#0975ba',
      };
      resetPasswordLock.show(theme);
    } else {
      resetPasswordLock.show();
    }
  }

  componentWillUnmount() {
    this.stylingSubscription.remove();
    resetPasswordLock.hide();
  }

  _onChange() {
    this.setState(getState());
  }

  render() {
    return (
      <div id='reset-container' />
    );
  }
}

ResetPassword.contextTypes = {
  router: PropTypes.object,
};

ResetPassword.propTypes = {};
